import { createAction, props } from '@ngrx/store';

export const selectCustomerForUpdate = createAction(
  '[Customers] Select Customer For Update',
  props<{ checked: boolean; groupId: string }>(),
);
